import { useEffect, type RefObject } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import type { AgGridReact } from 'ag-grid-react'

// Переход в карточку заявки из уведомления (`?itemId=&focus=&quoteId=&commentId=`).
// Квота или комментарий → сразу на страницу позиции (там точная прокрутка к
// data-focus-id); иначе — подсветка строки позиции в таблице.
export function useNotificationFocus(gridRef: RefObject<AgGridReact>, rowData: unknown) {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const focusItemId = searchParams.get('itemId')
  const focusKind = searchParams.get('focus')
  const focusQuoteId = searchParams.get('quoteId')
  const focusCommentId = searchParams.get('commentId')
  const redirectsToItem =
    (focusKind === 'quote' && !!focusQuoteId) || (focusKind === 'comment' && !!focusCommentId)

  useEffect(() => {
    if (!focusItemId) return
    if (focusKind === 'quote' && focusQuoteId) {
      navigate(`/request-items/${focusItemId}?focus=quote&quoteId=${focusQuoteId}`, {
        replace: true,
      })
    } else if (focusKind === 'comment' && focusCommentId) {
      navigate(`/request-items/${focusItemId}?focus=comment&commentId=${focusCommentId}`, {
        replace: true,
      })
    }
  }, [focusItemId, focusKind, focusQuoteId, focusCommentId, navigate])

  useEffect(() => {
    if (!focusItemId || !gridRef.current?.api) return
    // Пропускаем flash, если уже перенаправляем на страницу позиции
    if (redirectsToItem) return
    const api = gridRef.current.api
    const node = api.getRowNode(focusItemId)
    if (!node) return
    api.ensureNodeVisible(node, 'middle')
    node.setSelected(true, true)
    api.flashCells({ rowNodes: [node] })
  }, [focusItemId, redirectsToItem, gridRef, rowData])

  return { focusItemId, focusKind, showBanner: !!focusItemId && !redirectsToItem }
}
